<template>
  <div id="getStarted">
    <main class="get-started height_hid">
      <div class="row">
        <h1 class="for_height">{{ getTranslations.visitor_index_get_started_msg_1 }}
          <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="tablet"></div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="prize-img">
              <img :src="getTranslations.project_config_visitor_index_get_started_prizes_img"
                   :alt="getTranslations.project_config_index_duel_prizes">
            </div>
          </div>
          <div class="row">
            <div class="button">
              <a @click.prevent="goToRegistration"
                 id="submitBtn0"
                 style="cursor: pointer"
                 class="btn btn--large btn--main">
                {{ getTranslations.visitor_index_get_started }}
              </a>
            </div>
          </div>
          <div class="row"><div class="button">
            <router-link to="/login"
               class="btn btn--large btn--main gs_login_btn_desk">{{ getTranslations.visitor_login_submit_button_value_login}}
            </router-link></div></div>
        </div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']"
           :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img"
           alt="">
    </main>
    <main class="get-started-mobile">
      <div class="row">
        <div class="col-md-12 tablet"><img src="static/images/safari_uc.png" alt=""></div>
        <div class="col-md-12 button">
          <a @click.prevent="goToRegistration"
             id="submitBtn1"
             style="cursor: pointer"
             class="btn btn--large btn--main">
            {{ getTranslations.visitor_index_get_started }}
          </a>
          <div class="row"><div class="button">
            <router-link to="/login"
                         class="btn btn--large btn--main">{{ getTranslations.visitor_login_submit_button_value_login}}
            </router-link></div></div>
        </div>
        <div class="col-md-12 title">
          <h1>{{ getTranslations.visitor_index_get_started_msg_1 }}
            <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
        </div>
        <div class="col-md-12 prize-img">
          <img :src="getTranslations.project_config_visitor_index_get_started_prizes_img"
               :alt="getTranslations.project_config_index_duel_prizes">
        </div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']"
           :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img"
           alt="">
    </main>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';

export default {
  name: 'index',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components: { simplifyRegistration, subVerifyWifi },
  data() {
    return {
      showSimpleRegistrationModal: false,
    };
  },
  methods: {
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    goToRegistration() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialStripe',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue